import { FC, ReactNode, forwardRef, useEffect, useState } from "react";
import { Box, Dialog, Slide, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { BreackPointsType } from "../../types/AlertType";
import { useStyles } from './styles';
import { TransitionProps } from "@mui/material/transitions";

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export interface OptionalWidthModalProps {
    title?: string;
    open: boolean;
    breackPoint?: BreackPointsType;
    children: ReactNode;
    onClose: () => void;
    showCloseBtn?: boolean;
}

const OptionalWidthModal: FC<OptionalWidthModalProps> = ({
    open,
    onClose,
    children,
    breackPoint,
    title,
    showCloseBtn = true,
}) => {
    const classes = useStyles()();
    const [openLocal, setOpenLocal] = useState<boolean>(false);

    const handleCloseClick = () => {
        setOpenLocal(false);
        onClose();
    };

    useEffect(() => {
        setOpenLocal(open);
    }, [open]);

    const maxWidth: BreackPointsType = breackPoint ? breackPoint : "sm";

    return (
        <Dialog
            fullWidth
            maxWidth={maxWidth}
            open={openLocal}
            TransitionComponent={Transition}
        // onClose={onClose}
        >
            <Box className={classes.titleContainer}>
                <Typography sx={{ fontSize: { xs: 18, sm: 24 } }}>{title}</Typography>
                {showCloseBtn && (
                    <Box onClick={handleCloseClick} className={classes.closeBtn}>
                        <CloseIcon />
                    </Box>
                )}
            </Box>
            <Box className={classes.bodyContainer}>{children}</Box>
        </Dialog>
    );
};

export default OptionalWidthModal;